import { render, staticRenderFns } from "./Impugnacao.vue?vue&type=template&id=6005901e&scoped=true"
import script from "./Impugnacao.vue?vue&type=script&lang=js"
export * from "./Impugnacao.vue?vue&type=script&lang=js"
import style0 from "./Impugnacao.vue?vue&type=style&index=0&id=6005901e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6005901e",
  null
  
)

export default component.exports